/**
 * these may invoke api calls, or other async operations, push telemetry, etc.
 * but they MUST NOT depend on the state or other actions.
 */
import {createAsyncThunk} from '@reduxjs/toolkit';
import {AuthClientSingleton} from '../../utils/auth';
import {ErrorTags, EventNames} from '../../lib/analytics/events';
import {trackFn} from './util';

export const getAccessToken = createAsyncThunk(
    'users/getAccessToken',
    async (props: {email: string; password: string}) => {
        return trackFn(
            async () => await AuthClientSingleton.getAccessToken(props.email, props.password),
            EventNames.ACCESS_TOKEN_SUCCESS,
            ErrorTags.GET_ACCESS_TOKEN_ERROR,
        );
    },
);

export const getAccessTokenFromGoogleAuth = createAsyncThunk(
    'users/getAccessTokenFromGoogleAuth',
    async (props: {code: string}) => {
        return trackFn(
            async () => await AuthClientSingleton.getAccessTokenFromGoogleAuth(props.code),
            EventNames.GOOGLE_ACCESS_TOKEN_SUCCESS,
            ErrorTags.GOOGLE_ACCESS_TOKEN_ERROR,
        );
    },
);
